import { useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import InputField from "@_common/InputRuleFeild";
import LoginPageLyout from "@layouts/login";
import { adminForgotPassword } from "@services/auth.service";
import SimpleReactValidator from "simple-react-validator";
import { useParams, useNavigate } from "react-router-dom";
import { getValue } from "@utils/lodash";

interface ILoginPageProps {}

const LoginPage: React.FunctionComponent<ILoginPageProps> = (props: any) => {
  let navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [isLoading, setIsLoading] = useState(false);
  const [, forceUpdate] = useState(0);
  const [email, setEmail] = useState("");
  const [user_type] = useState("VENDOR");

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        setIsLoading(true);
        let payload = {
          email: email,
          user_type: user_type,
        };
        let resp = await adminForgotPassword(payload);
        if (resp) {
          // console.log(resp);
          setIsLoading(false);
          toast.success(getValue(resp, "message", ""));
          navigate(`/sent-email`);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  return (
    <LoginPageLyout>
      <div className="form-wrapper flex-1 d-flex position-relative">
        {/* <a href="#0" className="logo position-absolute"> */}
        <div className="logo position-absolute">
          <img src="/images/ascentlogo.png" className="img-fluid" />
        </div>
        {/* </a> */}

        <div className="m-auto form-wrapper__form">
          <NavLink to="/login">
          {/* <NavLink to="/vendor/login"> */}
            {/* <a href="#0" className="back-btn"> */}
			<div className="back-btn">
              <img 
                src="/images/back-arrow.svg"
                className="img-fluid  back-arrow"
              />
              Back
			  </div>
            {/* </a> */}
          </NavLink>
          <h2>Password Reset (Vendor)</h2>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <InputField
              inputType="TEXT"
              id="email"
              name="email"
              value={email}
              onChange={(e: any) => setEmail(e.target.value)}
              placeholder="Enter Email"
              className="form-control"
              label="Email"
              validator={simpleValidator}
            />
          </div>
          <div className="form-cta-button">
            {isLoading ? (
              <button className="form-cta-button__primary-btn form-cta-button__primary-btn--reset-btn">
                Please wait...
              </button>
            ) : (
              <button
                className="form-cta-button__primary-btn form-cta-button__primary-btn--reset-btn"
                onClick={handleSubmit}
              >
                Get Reset Link
              </button>
            )}
          </div>
        </div>
      </div>
    </LoginPageLyout>
  );
};

export default LoginPage;
